import React, { useEffect, useState } from "react";
import "../assets/style/pages/Actualities.scss";
import Carousel from "../components/Carousel";
import * as Icon from 'react-bootstrap-icons';
import Viewer from "../components/Viewer";
import { trackEvent } from "../components/CookiePopup"; 

const Article = ({ article, isNew, isOpen, toggleViewer }) => {
    return (
        <div className={`${isNew ? 'actuality-item new' : 'actuality-item col-xl-3 col-md-5'} ${isOpen ? 'open' : ''}`}>
            <div className="actuality-article">
                <div className={`${isNew ? 'col-lg-6' : 'col-12'} actuality-carousel`}>
                    <Carousel item={article} />
                </div>
                <div className={`${isNew ? 'col-lg-6' : 'col-12'} card-body`}>
                    <h3 className="card-title">{article.title}</h3>
                    <div className="pill-container">
                        {isNew && <div className="pill primary-action primary-text"><Icon.Bell size={15} />Dernière nouveauté</div>}
                        {article.category && <div className="pill"><Icon.Tag size={15} />{article.category}</div>}
                    </div>
                    <p className={`actuality-content`}>{article.text}</p>
                    <div className="actuality-footer">
                        <div>
                            <div className="lightItalic">Publié le {new Date(article.date).toLocaleDateString()}</div>
                            <div className="lightItalic">{article.forename} {article.name}</div>
                        </div>
                        <button className="action-btn small" onClick={()=>toggleViewer(article)}><Icon.Plus size={30} /></button>
                    </div>
                </div>
            </div>
        </div>
    )
}


const Actualities = () => {

    const [articles, setArticles] = useState([]);
    const [viewerArticle, setViewerArticle] = useState('');
    const [openViewer, setOpenViewer] = useState(false);

    useEffect(() => {
        if (openViewer) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'scroll';
        }

        return () => {
            document.body.style.overflow = 'scroll';
        };
    }, [openViewer]);

    const toggleViewer = (article) => {
        if (article) {
            trackEvent('article_open', {
                article_id: article.id,
                article_title: article.title
            });

            setViewerArticle(article);
            setTimeout(() => {
                setOpenViewer(true);
            }, 100);
        } else {
            setOpenViewer(false);
            setTimeout(() => {
                setViewerArticle('');
            }, 600);
        }
    }

    const fetchArticles = async () => {
        try {
            const res = await fetch('https://havredepriya.fr/api/actualities.php');
            if (!res.ok) throw new Error('Network response was not ok');
            const data = await res.json();
            setArticles(data);
        } catch (error) {
            setArticles([]);
        }
    }

    useEffect(() => {
        fetchArticles();
    }, []);

    return (
        <div className="page-container actuality-container">
            {articles.length > 0 ? (
                <div className="section">
                    <div className="card-container">
                        <Article key={articles[0].id} article={articles[0]} isNew={true} toggleViewer={toggleViewer} />
                    </div>
                    <div className="card-container">
                        {articles.slice(1).map(article => (
                            <Article key={article.id} article={article} toggleViewer={toggleViewer}/>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="text-center m-5">
                    <h2>Pas d'actualités pour le moment</h2>
                </div>
            )}
            <Viewer article={viewerArticle} isOpen={openViewer} toggleViewer={toggleViewer} />
        </div>
    );
}

export default Actualities;